import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useDepartmentCreate } from '@/module/Department/model/DepartmentQuery';
import {
  DepartmentSchema,
  defaultDepartmentValues,
  departmentSchema,
} from '@/module/Department/model/DepartmentSchema';

import { useAppNotification } from '@feature/utils';

import { DepartmentForm } from './DepartmentForm';

export function DepartmentCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useDepartmentCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: DepartmentSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newDepartment => {
        notification.success();
        navigate({
          to: '/administration/department/$departmentId',
          params: { departmentId: String(newDepartment.id) },
        });
      },
    });
  };

  return (
    <DepartmentForm
      title={t('departments.form.title.create')}
      schema={departmentSchema}
      defaultValues={defaultDepartmentValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
